import React from 'react';
import { X } from 'lucide-react';
interface LegalPopupProps {
  title: string;
  content: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
}
export function LegalPopup({
  title,
  content,
  isOpen,
  onClose
}: LegalPopupProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-200">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col" data-id="element-201">
        <div className="p-6 border-b border-gray-200 flex justify-between items-center" data-id="element-202">
          <h2 className="text-2xl font-bold text-indigo-900" data-id="element-203">{title}</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 transition-colors" data-id="element-204">
            <X size={24} data-id="element-205" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto" data-id="element-206">{content}</div>
        <div className="p-6 border-t border-gray-200 flex justify-end" data-id="element-207">
          <button onClick={onClose} className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-md transition-colors" data-id="element-208">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}